import { render, staticRenderFns } from "./dashboard-admin.vue?vue&type=template&id=4f867591"
import script from "./dashboard-admin.vue?vue&type=script&lang=js"
export * from "./dashboard-admin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports